import gql from 'graphql-tag';

// `defaultCoverageMasterId` and `version` sit at the root beside each other: they
// say WHICH row and WHICH revision to act on. The nested
// `DefaultCoverageMasterUpdateInput` says WHAT to change, and a concurrency token
// is not one of the changes - the same shape the opt-out update settled on after
// getting it wrong once.
//
// Every field in the nested input is optional and absent means untouched: APMS
// COALESCEs what it is not sent, which is what lets a price-only edit leave the
// priority exactly where it was. COALESCE cannot say "remove the end date", so
// that is `clearEndTs: true` with no endTs (the server rejects the two together);
// see buildUpdateInput in containers/DefaultCoverageMasters.
//
// A lost version race comes back as `errorCode: 'STALE_VERSION'` - branched on
// the exception class server-side, so it does not drift when the copy is
// reworded - with the human sentence in `errors[0]`. The returned master carries
// the new `version`, so the refetched row is immediately editable again.
const updateDefaultCoverageMasterMutation = gql`
  mutation UpdateDefaultCoverageMaster($input: UpdateDefaultCoverageMasterInput!) {
    updateDefaultCoverageMaster(input: $input) {
      success
      errors
      errorCode
      defaultCoverageMaster {
        id
        masterType
        productId
        productCode
        version
        priceDs
        startTs
        endTs
        resolving
      }
    }
  }
`;

export default updateDefaultCoverageMasterMutation;
